<template>
    <div data-testid="enviar-entradas-view">
        <div class="tw:grid tw:grid-cols-1 tw:lg:grid-cols-3 tw:gap-6">
            <div class="tw:lg:col-span-2">
                <!-- Unified sub-view header -->
                <div class="tw:flex tw:items-center tw:justify-between tw:mb-6">
                    <h2 class="tw:text-xl tw:font-bold tw:text-slate-900 tw:m-0">{{ $t('perfil.enviar_entradas') }}</h2>
                    <Button variant="default" data-testid="enviar-entradas-btn-volver" @click="emit('volver')">
                        <i class="material-icons tw:text-sm">arrow_back</i>
                        {{ $t('perfil.volver') }}
                    </Button>
                </div>
                <ListaEntradasEnvio
                    :pedido="pedido"
                    :seleccionadas="seleccionadas"
                    :is-all-selected="isAllSelected"
                    :is-some-selected="isSomeSelected"
                    @toggle-entrada="toggleEntrada"
                    @toggle-all="toggleAll"
                />
            </div>
            <div class="tw:lg:col-span-1">
                <div class="tw:sticky tw:top-6">
                    <CardEnvio
                        :seleccionadas="seleccionadas"
                        :nombre="nombre"
                        :apellidos="apellidos"
                        :email="email"
                        :can-send="canSend"
                        :loading="loading"
                        :error="error"
                        @update:nombre="nombre = $event"
                        @update:apellidos="apellidos = $event"
                        @update:email="email = $event"
                        @enviar="enviarYVolver"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { computed } from 'vue';
    import { useEnviarEntradas } from '@/composables/front/perfil/useEnviarEntradas';
    import Button from '@/modules/front/ui/Button.vue';
    import ListaEntradasEnvio from '../components/EnviarEntradas/ListaEntradasEnvio.vue';
    import CardEnvio from '../components/EnviarEntradas/CardEnvio.vue';

    const props = defineProps({
        pedido: { type: Object, required: true },
    });

    const emit = defineEmits(['volver']);

    const pedidoRef = computed(() => props.pedido);

    const {
        email,
        nombre,
        apellidos,
        loading,
        error,
        seleccionadas,
        isAllSelected,
        isSomeSelected,
        toggleEntrada,
        toggleAll,
        canSend,
        enviar,
    } = useEnviarEntradas(pedidoRef);

    const enviarYVolver = async() => {
        const ok = await enviar();
        if (ok) emit('volver');
    };
</script>
